/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import { Method } from "axios";
import { CATALOG } from "./product";

interface Methods {
  [extraProps: string]: Method;
}
export const METHOD: Methods = {
  DELETE: "DELETE",
  PUT: "PUT",
  POST: "POST",
  GET: "GET",
  PATCH: "PATCH",
};

//login flow
export const CSR_LOGINIDENTITY = "/session/login";
export const CSR_LOGOUTIDENTITY = "/store/0/loginidentity/@self";
export const USER_ROLES = "/store/0/person/{userId}?profileName=IBM_Assigned_Roles_Details";
export const ONLINE_STORE = "/online-stores";
export const ONLINE_STORE_DESCRIPTIONS = "/online-stores/{id}/descriptions";
//customer
export const CSR_SEARCHCUSTOMER = "/users/manageable";
// export const CSR_CUSTOMER = "/users/{id}"; // Esto es en teoría para Commerce V9
export const CSR_CUSTOMER =
  "/store/{storeId}/person/{id}?q=registeredUsersICanManage&profileName=IBM_User_Registration_Details&profileName&responseFormat=json";
export const CSR_CREATECUSTOMER = "/users";
export const CSR_RESETPASSWORD = "/users/{id}/password-reset";
export const CSR_RESETPASSWORD_V2 = "/store/{storeId}/person/updateMemberPassword?mode=resetPasswordOnBehalf";
export const CSR_UPDATECUSTOMER_BY_ID = `/store/{storeId}/person/{useId}`;
export const CSR_CUSTOMER_V2 =
  "/store/{storeId}/person/{id}?q=registeredUsersICanManage&profileName=IBM_User_Registration_Details&profileName&responseFormat=json";
export const CSR_SEARCHCUSTOMER_V2 =
  "/store/{storeId}/person?q=registeredUsersICanManage&profileName=IBM_User_List_Basic_Summary&startIndex=0&responseFormat=json";

//orders
export const ORDERS = "/orders";
export const ORDERS_CAN_WORK_ON_BEHALF =
  "/store/10151/order?q=ordersICanWorkonbehalf&profileName=AVATAR_Report_Order_Summary";
/* export const ORDERS_CAN_WORK_ON_BEHALF = `${ORDERS}/can-work-on-behalf`; */
export const UNLOCK_ORDER = `/store/{storeId}/cart/{cartId}/unlock`;
export const LOCK_ORDER = `/store/{storeId}/cart/{cartId}/lock`;
export const ORDERS_GET_BY_ID = `${ORDERS}/{id}`;
export const ORDERS_GET_ORDERITEM_BY_ORDERID = `/store/{storeid}/order/{orderid}`;
export const CANCEL_ORDER = `${ORDERS}/{id}/cancel`;
export const ORDERS_POST_COMMENT_BY_ORDERID = `/store/{storeId}/order/{orderId}/comment?mode&responseFormat`;
// wcs/resources/store/{{store}}/order/{{orderId}}/comment?mode&responseFormat
export const ORDERS_GET_COMMENT_BY_ORDERID_V2 = `${ORDERS}/{orderid}/comments`;
export const ORDERS_GET_COMMENT_BY_ORDERID = `/store/{storeid}/order/{orderid}/comment`;
///wcs/resources/store/{{store}}/order/{{orderId}}/comment
export const RE_ORDER = `/store/{storeId}/cart/copy_order`;

//organization
export const ORG_GET_BY_ORGID = `/organizations/{orgid}`;
export const GET_ORGS = `/organizations/manageable`;

//sales

export const SALES_CAN_WORK_ON_BEHALF =
  "/store/{storeId}/order?q=ordersICanWorkonbehalf&profileName=AVATAR_Sales_Report_Order_Summary";

//resend XML
export const RESEND_XML_ORDER = `/store/{storeId}/order/transfer_order/{orderId}`;
export const RESEND_PAYMENT_INFO = `/store/{storeId}/order/process_payment_and_transfer_order/{orderId}`;

//Client report
export const CLIENT_REPORT =
  "/store/{storeId}/person?q=registeredUsersICanManage&profileName=AVATAR_User_List_Details&retrievePendingGuestOrders=true";
export const CLIENT_REPORT_MEMBER =
  "/store/{storeId}/person?q=registeredUsersICanManage&profileName=AVATAR_User_MemberState_List_Details&retrievePendingGuestOrders=true";
//Top Client report
export const TOP_CLIENT_REPORT = "/store/{storeId}/order/totalOrders";
export const TOP_CLIENT_REPORT_DETAIL = "/store/{storeId}/order/byBuyerId/{buyerId}?responseFormat=json";
//product  cat=10698   catalog =10051
export const PRODUCT_REPORT =
  "/store/{storeId}/productReport?contractId=10501&responseFormat=json&languageId={languageId}";
export const CATEGORIES =
  "/store/{storeId}/categoryview/@top?responseFormat=json&catalogId={catalogId}&contractId=10502&contractId=10501&contractId=10003&langId={langId}&currency=USD&requestType=GET&depthAndLimit=*";

//TOP products report

export const TOP_PRODUCT_REPORT_URL = "/store/{storeId}/order/totalOrderItems?&lang={lang}";
export const TOP_PRODUCT_VARIANTS_URL = "/store/{storeId}/order/totalOrderItemsSkus?languageId={languageId}";
export const TOP_PRODUCT_REPORT_DETAIL_URL =
  "/store/{storeId}/productview/byIds?catalogId={catalogId}&id=119465&id=124211";

//Dashboard
export const AVG_ORDERS_URL = "/store/{storeId}/orderReport/salesStatsReport?responseFormat=json";
export const SALES_PER_HOUR_URL = "/store/{storeId}/orderReport/salesPerHourReport?responseFormat=json";
export const TOP_PRODUCTS_OF_DAY_URL =
  "/store/{storeId}/order/totalOrderItems?numRows=5&order=desc&lang={lang}&bySkus=true";
export const TOP_PRODUCTS_SEARCHED_URL =
  "/store/{storeId}/orderReport/searchTermStatistics?responseFormat=json&languageId={languageId}";

//Product Prices
export const PRICES_LIST_URL = "/store/{storeId}/order/priceLists?responseFormat=json";
export const PRODUCT_PRICES_URL = "/store/{storeId}/order/productPriceList?responseFormat=json";

//Inventario de productos

export const CATALOG_LIST_URl = "/store/{storeId}/catalog?profileName=IBM_Admin_Summary";
export const INVENTORY_BY_CATALOG_URL =
  "/store/{storeId}/orderReport/inventoryReport?responseFormat=json&languageId={languageId}";
export const INVENTORY_BY_PRODUCT_NAME =
  "/store/{storeId}/orderReport/inventoryReport/bySearchTerm/{term}?responseFormat=json&languageId={languageId}";
export const INVENTORY_BY_PARTNUMBER_URL =
  "/store/{storeId}/orderReport/inventoryReport/byPartNumber/{partnumber}?responseFormat=json&languageId={languageId}";

//Reporte detallado de promociones

export const DETAILED_PROMOTIONS_URL =
  "/store/{storeId}/orderReport/promosDetailsReport?responseFormat=json&languageId={languageId}";

//Reporte  de auditoria de ordenes
export const AUDIT_ORDERS_URL = "/store/{storeId}/orderReport/auditOrdersReport?responseFormat=json";

//Activar usuario
export const SEARCH_USER_BY_LOOGON_ID_URL =
  "/store/{storeId}/person?q=registeredUsersICanManage&profileName=AVATAR_User_MemberState_List_Details&logonId={logonId}";
export const UPDATE_USER_STATUS_URL = "/store/{storeId}/useractivate/updateState";

// Stores
export const STORES_BY_TENANT = "/stores/by-tenant";

// Reports Orders Summary
export const REPORTS_ORDERS_SUMMARY = "/reports/orders/summary";
export const REPORTS_ORDERS_ITEMS = "/reports/orders/items";
